import React, { useState } from 'react';
import { Button } from '@cokitchen/cokitchen-components';
import { ReactComponent as CloseIcon } from 'assets/icons/close-icon.svg';
import CurrencyInput from 'components/base/currency-input';
import useOrdersContext from 'contexts/orders.context';
import GroupOrderService from 'services/group-order.service';

type Props = {
  onClose: () => void;
};

const LimitModal = (props: Props) => {
  const { onClose } = props;
  const { createGroupOrderObject, setCreateGroupOrderObject } = useOrdersContext();
  const [limit, setLimit] = useState(createGroupOrderObject.group_spend_limit ?? '');

  return (
    <div className='flex flex-col justify-between gap-8 py-4 z-10 absolute bg-white shadow-sm w-[90%] top-[30%]'>
      <div className='w-full flex justify-end'>
        <CloseIcon className='cursor-pointer' onClick={onClose} />
      </div>
      <p className='text-gray-10font-semibold'>Set a spending limit for members</p>
      <div className='relative max-w-[40%] self-center flex items-center gap-3'>
        <p className='absolute left-[-32px] top-[10px] text-[32px] leading-[41.6px] font-semibold'>
          ₦
        </p>
        <CurrencyInput
          prefix=''
          placeholder='0'
          onChange={(v) => setLimit(v)}
          defaultValue={limit}
          autoFocus
          inputClassName='bg-[transparent] border-none text-[32px] leading-[41.6px] text-center'
        />
      </div>

      <div className='flex items-end justify-end gap-4'>
        <Button
          variant='block'
          color='gray'
          className='mt-8 h-[41px] w-[139px] !bg-[#F2F2F2] !border-[#F2F2F2] !text-[#2E3031]'
          onClick={() => onClose()}>
          Cancel
        </Button>
        <Button
          variant='block'
          color='primary'
          className='h-[41px] w-[139px]'
          onClick={() => {
            GroupOrderService.AddLimit(limit, (prevState) => setCreateGroupOrderObject(prevState));
            onClose();
          }}
          disabled={!limit}>
          Confirm
        </Button>
      </div>
    </div>
  );
};

export default LimitModal;
